import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useAtomValue, useSetAtom } from 'jotai';
import {
  CircularProgress,
  Fab,
  Tooltip,
  Typography,
  Stack,
} from '@mui/material';
import CallEndRoundedIcon from '@mui/icons-material/CallEndRounded';
import useAPI from '../../../../api';
import {
  notifyUpdateCallAtom,
  notifyEndCallAtom,
} from '../../../../Atoms/HubAtoms';
import CallTimer from './CallTimer';
import Information from '../../../PracticesPage/Components/Information';
import { FullSizeCenteredFlexBox } from '../../../../Components/FlexBox';
import { openSnackbarAdviseAtom } from '../../../../Atoms';

const CallKeyPad = function CallKeyPad({ callId }) {
  const intl = useIntl();
  const API = useAPI();
  const notifyUpdateCall = useAtomValue(notifyUpdateCallAtom);
  const notifyEndCall = useAtomValue(notifyEndCallAtom);
  const setOpenSnackbarAdvise = useSetAtom(openSnackbarAdviseAtom);
  const [droppingCall, setDroppingCall] = useState(null);
  const [startTime, setStartTime] = useState(undefined);
  const [stopTime, setStopTime] = useState(undefined);

  const handleDropCall = () => {
    if (callId) {
      setDroppingCall(true);
      API.dropCall(
        callId,
        { silent: true },
        () => {
          setDroppingCall(false);
          setOpenSnackbarAdvise({
            message: intl.messages.CALL_DROPPED,
            severity: 'info',
          });
        },
        () => {
          setDroppingCall(null);
          setOpenSnackbarAdvise({
            message: intl.messages.CALL_DROPPED_ERROR,
            severity: 'error',
          });
        }
      );
    }
  };

  useEffect(() => {
    if (
      notifyUpdateCall &&
      notifyUpdateCall?.id === callId &&
      notifyUpdateCall?.callStatus === 'Connected'
    ) {
      setStartTime(new Date(notifyUpdateCall?.connectedOn));
    }
  }, [notifyUpdateCall]);

  useEffect(() => {
    if (
      notifyEndCall &&
      notifyEndCall?.id === callId &&
      notifyEndCall?.callStatus === 'Disconnected'
    ) {
      setStopTime(new Date(notifyEndCall?.disconnectedOn));
      setDroppingCall(false);
    }
  }, [notifyEndCall]);

  return (
    <FullSizeCenteredFlexBox justifyContent="space-between">
      {!startTime ? (
        <Stack
          direction="column"
          spacing={2}
          sx={{
            width: "30%",
            justifyContent: "center",
            alignItems: "center"
          }}>
          <div className="dot-flashing" />
        </Stack>
      ) : (
        <Information
          styles={{ root: { gap: '0px' } }}
          caption={intl.messages.CALL_DURATION}
          value={<CallTimer startTime={startTime} stopTime={stopTime} />}
        />
      )}
      {droppingCall === false ? (
        <Typography variant="h6" sx={{ fontSize: '1rem', color: '#5A5A5A' }}>
          {intl.messages.CALL_DROPPED}
        </Typography>
      ) : (
        <Tooltip title={intl.messages.END_CALL} placement="bottom">
          <Fab
            id="end-call-fab"
            size="large"
            color="error"
            sx={{ boxShadow: 'none', width: '100px', borderRadius: '32px' }}
            onClick={handleDropCall}
          >
            {droppingCall ? (
              <CircularProgress color="secondary" size="24px" />
            ) : (
              <CallEndRoundedIcon />
            )}
          </Fab>
        </Tooltip>
      )}
    </FullSizeCenteredFlexBox>
  );
};

CallKeyPad.propTypes = {
  callId: PropTypes.string,
};
export default CallKeyPad;
